export default "__VITE_ASSET__e350bec1__"